// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1diWe","savePackageButton":"ClientWallet_savePackageButton__3rwGS"};